import type { LintReport } from '../../api/knowledge';
import './LintSummary.css';

interface Props {
  report: LintReport;
}

export function LintSummary({ report }: Props) {
  const items: Array<{ label: string; count: number; tone: 'warn' | 'info' | 'ok' }> = [
    { label: 'Contradictions', count: report.contradictions.length, tone: 'warn' },
    { label: 'Orphans', count: report.orphans.length, tone: 'info' },
    { label: 'Stuck stubs', count: report.stuck_stubs.length, tone: 'warn' },
    { label: 'Stale', count: report.stale.length, tone: 'info' },
    { label: 'Broken sources', count: report.broken_sources.length, tone: 'warn' },
  ];

  const totalIssues = items.reduce((sum, item) => sum + item.count, 0);

  return (
    <div className="lint-summary glass">
      <div className="lint-summary__header">
        <div className="label">Health</div>
        <div
          className={`lint-summary__total${
            totalIssues === 0 ? ' lint-summary__total--ok' : ''
          }`}
        >
          {totalIssues === 0 ? 'All clear' : `${totalIssues} issues`}
        </div>
      </div>
      <ul className="lint-summary__list">
        {items.map((item) => (
          <li key={item.label} className="lint-summary__row">
            <span className="lint-summary__label">{item.label}</span>
            <span
              className={`lint-summary__count lint-summary__count--${
                item.count === 0 ? 'zero' : item.tone
              }`}
            >
              {item.count}
            </span>
          </li>
        ))}
      </ul>
      <div className="lint-summary__footer">
        {report.pages_scanned} pages scanned
      </div>
    </div>
  );
}
